import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppButton from '../../shared/components/app-button/AppButton';

function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="d-flex align-items-center justify-content-center flex-1">
      <div className="d-flex flex-column align-items-center">
        <p>Page Not Found</p>
        <AppButton
          variant="secondary"
          btnText="Got to home"
          onClick={() => navigate('/')}
        />
      </div>
    </div>
  );
}

export default NotFoundPage;
